import { LegalLayout } from "@/components/site/LegalLayout";
import { CABINET } from "@/lib/content";

export default function Confidentialite() {
  return (
    <LegalLayout title="Politique de confidentialité" eyebrow="Protection des données (RGPD)" testid="confidentialite-page">
      <h2>Responsable du traitement</h2>
      <p>{CABINET.firm} — {CABINET.name}, avocate, {CABINET.address.join(", ")} — <a href={`mailto:${CABINET.email}`}>{CABINET.email}</a>.</p>

      <h2>Données collectées</h2>
      <p>Via le formulaire de contact : nom et prénom, adresse e-mail, téléphone (facultatif), objet et contenu de votre message, ainsi que la date de votre consentement.
        Nous vous invitons à ne communiquer, à ce stade, que les informations strictement utiles à une première prise de contact, et à ne transmettre aucune donnée de santé détaillée.</p>

      <h2>Finalité et base légale</h2>
      <p>Ces données sont utilisées uniquement pour répondre à votre demande et, le cas échéant, organiser un rendez-vous. Le traitement repose sur votre consentement
        (art. 6.1.a du RGPD), recueilli par la case à cocher du formulaire, puis sur les mesures précontractuelles prises à votre demande (art. 6.1.b).</p>

      <h2>Destinataires et secret professionnel</h2>
      <p>Les données sont destinées exclusivement à Maître Pauline Rège Chanal. Elles sont couvertes par le secret professionnel de l'avocat et ne sont ni vendues,
        ni cédées, ni utilisées à des fins de prospection. Les prestataires techniques (hébergement, messagerie) n'y accèdent que pour les besoins du service.</p>

      <h2>Durée de conservation</h2>
      <p>Les messages n'ayant pas donné lieu à l'ouverture d'un dossier sont conservés au maximum 3 ans à compter du dernier contact. Si un dossier est ouvert,
        les données sont conservées pendant la durée de la relation puis archivées selon les délais légaux applicables à la profession.</p>

      <h2>Vos droits</h2>
      <p>Vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité de vos données, ainsi que du droit de retirer
        votre consentement à tout moment. Pour les exercer : <a href={`mailto:${CABINET.email}`}>{CABINET.email}</a> ou par courrier au cabinet.</p>
      <p>Vous pouvez introduire une réclamation auprès de la CNIL : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>.</p>

      <h2>Cookies</h2>
      <p>Ce site n'utilise pas de cookies publicitaires. La carte d'accès est fournie par Google Maps, qui peut déposer ses propres cookies lors de son affichage.</p>
    </LegalLayout>
  );
}
